import { Observable } from 'rxjs';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { Qry } from '../query-facade';
import * as actions from './category-group.actions';
import { CategoryGroup } from './category-group.model';

export class CategoryGroupStoreFacade extends AccountObjectStoreFacade<CategoryGroup> {

    getAll(): Observable<Array<CategoryGroup>> {
        return this.select(Qry.getInstance().categoryGroup.byActiveAccount);
    }

    getFiltered(): Observable<Array<CategoryGroup>> {
        return this.select(Qry.getInstance().categoryGroup.filtered);
    }

    create(categoryGroup: CategoryGroup): void {
        this.dispatch(new actions.SubmitAction(categoryGroup));
    }

    update(categoryGroup: CategoryGroup): void {
        this.dispatch(new actions.SubmitAction(categoryGroup));
    }

    insert(categoryGroup: CategoryGroup): void {
        this.dispatch(new actions.SubmitAction(categoryGroup, {persistable: true, restful: false}));
    }

    remove(categoryGroup: CategoryGroup, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(categoryGroup, options));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.store-facade.ts